import { Breadcrumb, Flex, Layout } from "antd";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { Outlet,useLocation } from "react-router";
import Footer from "../components/Footer";
// import { breadcrumbStore } from "../store/breadcrumbStore";
import { generateBreadcrumbItems } from "../utils/breadcrumUtils";

export default function MainLayout(){
  const location = useLocation();

 
  return (
    <Layout style={{ height: '100vh' }} >
      <Sidebar/>
      <Layout style={{ height: '100%' }} >
        <Flex vertical style={{ height: '100%' }} >
          <Header/>
          <Layout.Content style={{ padding: 24, flex: 1, overflow: 'auto' }} >
            <Breadcrumb
              items={generateBreadcrumbItems(location)}
              style={{ marginBottom: 24 }}
            />
            <Outlet/>
          </Layout.Content>
          <Footer/>
        </Flex>
      </Layout>
    </Layout>
  )
}